<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
        <div class="info-reservation">
          <div class="wrap-info-reservation">
            <div v-if="!$isEmpty($store.state.selected_outlet)" class="wrap-info-reservation-content">
              <div class="info-reservation-title">
                {{ $store.state.selected_outlet.name }}
              </div>
              <div class="info-reservation-subtitle">
                <v-icon size="16" color="#9B9B9B" class="mr-1">
                  mdi-clock-outline
                </v-icon>
                {{ working_hours }}
              </div>
              <div v-if="Number($store.state.selected_outlet.reservation.minimum_order_amount)" class="info-reservation-subtitle">
                <v-icon size="16" color="#9B9B9B" class="mr-1">
                  mdi-cash
                </v-icon>
                Minimal order <span v-mask-money="$store.state.selected_outlet.reservation.minimum_order_amount" class="ml-1" />
              </div>
            </div>
            <div class="ml-3">
              <div class="primary--text text-non-direction font-weight-bold cursor-pointer" @click="sheetTerm = true">
                Lihat Ketentuan
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="mt-5">
          <div class="mb-6">
            <v-dialog ref="dialog_date" v-model="dialog.date" :return-value.sync="sendToForm.reserve_date" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <label class="l-input">Tanggal</label>
                <v-text-field v-model="computedDateFormatted" prepend-inner-icon="mdi-calendar" hide-details dense readonly outlined v-bind="attrs" v-on="on" />
              </template>
              <v-date-picker v-model="sendToForm.reserve_date" scrollable :min="minDate">
                <v-spacer />
                <v-btn text color="primary" class="text-none" @click="dialog.date = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" class="text-none" @click="selectDate()">
                  Ok
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </div>
          <div class="mb-6">
            <label class="l-input">Pukul</label>
            <!-- <ValidationProvider v-slot="{ errors }" name="reserve_time" :rules="{ required: true, reserveTime: { reserve_hour, reserve_minute }}">
              <v-text-field v-model="sendToForm.reserve_time" placeholder="Pilih waktu reservasi" readonly outlined prepend-inner-icon="mdi-clock-outline" :error-messages="errors" dense class="input-reserve-time" @click="openDialogTime" />
            </ValidationProvider> -->
            <ValidationProvider v-slot="{ errors }" name="reserve_time" :rules="{ required: true }">
              <!-- <v-text-field v-model="sendToForm.reserve_time" placeholder="Pilih waktu reservasi" readonly outlined prepend-inner-icon="mdi-clock-outline" :error-messages="errors" dense class="input-reserve-time" @click="openDialogTime" /> -->
              <v-select v-model="sendToForm.reserve_time" :placeholder="!time_disabled ? 'Pilih waktu reservasi' : 'Jam reservasi tidak tersedia'" :items="list_hour" outlined prepend-inner-icon="mdi-clock-outline" :error-messages="errors" dense :disabled="time_disabled" class="input-reserve-time" @change="selectTime()" />
            </ValidationProvider>
            <div v-if="availability_slot > 0" class="guest-availability-slot">
              <span v-if="visitorStore || guestStore">
                Tersedia untuk {{ availability_slot }} pengunjung
              </span>
              <span v-else>
                Tersedia untuk {{ availability_slot }} meja
              </span>
            </div>
          </div>
          <template v-if="!time_disabled">
            <div class="text-center">
              <div v-if="visitorStore" class="font-16 grey--text">
                Jumlah Pengunjung
              </div>
              <div v-else-if="!guestStore" class="font-16 grey--text">
                Jumlah Meja
              </div>
              <div v-else class="font-16 grey--text">
                Jumlah Kursi
              </div>
            </div>
            <div class="d-flex align-center justify-center py-4">
              <v-btn
                color="primary"
                fab
                outlined
                small
                :disabled="sendToForm.total_guest <= 1"
                @click="onChangeGuest(sendToForm.total_guest - 1)"
              >
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <h1 class="display-3 px-5 font-weight-medium">
                {{ sendToForm.total_guest }}
              </h1>
              <v-btn
                color="primary"
                fab
                outlined
                small
                :disabled="isGuestOverLimit"
                @click="onChangeGuest(sendToForm.total_guest + 1)"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
            <!-- hide request pak ali melalui group support pada tanggl 24 februari 2025 -->
            <!-- <div class="mt-4 text-center">
              <div class="font-12  grey--text">
                1 Meja bisa untuk 4 pengunjung
              </div>
            </div> -->
          </template>
          <template v-else>
            <div class="list-with-icon list-limit-table">
              <div class="list-item-icon mr-2">
                <v-icon color="#FF931E" size="20">
                  mdi-alert-outline
                </v-icon>
              </div>
              <div class="list-item-content">
                <div class="list-item-text">
                  Jam reservasi tidak tersedia di tanggal terpilih. Coba pilih tanggal lain.
                </div>
              </div>
            </div>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <div class="__menu-bottom menu-full">
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
            <v-btn type="submit" :disabled="disableNext || time_disabled || isGuestOverLimit" color="primary" block x-large class="text-none" @click="selectMenu">
              Pilih menu
            </v-btn>
          </v-col>
        </div>
      </v-row>
    </ValidationObserver>

    <div v-if="dialog.reserve_time" class="reserve-overlay" />

    <div v-if="dialog.reserve_time" class="reserve-dialog">
      <div class="reserve-dialog-wrap">
        <v-card>
          <v-card-text class="pa-4">
            <div class="d-flex align-center mb-5">
              <div class="font-16 black--text">
                Pilih waktu
              </div>
              <v-spacer />
              <v-btn icon size="28" @click="dialog.reserve_time = false">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
            <div class="px-2">
              <div class="d-flex align-center justify-center">
                <div class="text-reserve-time">
                  Jam
                </div>
                <div class="text-reserve-time">
                  Menit
                </div>
              </div>
              <scroll-picker-group class="d-flex">
                <scroll-picker v-model="reserve_hour" :options="list_hours" />
                <scroll-picker v-model="reserve_minute" :options="list_minutes" />
              </scroll-picker-group>
            </div>
            <v-btn block large depressed color="primary" class="text-none" @click="selectTime()">
              Pilih
            </v-btn>
          </v-card-text>
        </v-card>
      </div>
    </div>

    <v-dialog v-model="dialog.max_visitor" max-width="320">
      <v-card>
        <v-card-text class="pt-8">
          <div class="mb-6">
            <v-img src="@/assets/images/svg/max_visitor.svg" width="166" height="166" class="mx-auto" />
          </div>
          <div class="text-center">
            <div class="title-dialog">
              Tidak cukup Meja untuk Reservasi :(
            </div>
            <div class="subtitle-dialog mt-4">
              Jumlah Meja yang dimasukan melebihi Meja yang tersedia. Hubungi pihak resto untuk detail Reservasi.
            </div>
          </div>
          <v-btn block large depressed color="primary" class="text-none mt-6" @click="dialog.max_visitor = false">
            Ya, saya mengerti
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-bottom-sheet v-model="sheetTerm" persistent :content-class="'sheet-full'">
      <v-sheet style="height: 100%">
        <v-container fluid>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
              <div class="d-flex align-center py-3 px-6">
                <h2 class="font-20">
                  <span class="font-weight-bold d-flex align-center">
                    Ketentuan
                  </span>
                </h2>
                <v-spacer />
                <v-btn text icon @click="sheetTerm = false">
                  <v-icon class="black--text">
                    mdi-close
                  </v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="info-reservation">
                <div class="pa-4 text-center">
                  <div class="banner-reservation-logo">
                    <template v-if="$store.state.selected_outlet">
                      <img :src="$store.state.selected_outlet.logo" alt="Logo">
                    </template>
                  </div>
                  <div class="banner-text">
                    <template v-if="$store.state.selected_outlet">
                      {{ $store.state.selected_outlet.name }}
                    </template>
                  </div>
                </div>
              </div>
              <template v-if="$store.state.selected_outlet && !$isEmpty($store.state.selected_outlet.setting)">
                <div class="mt-6 font-14" v-html="$store.state.selected_outlet.setting.tnc_store_content" />
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import { getLocale } from '@/utils/locale'
import {
  checkReserve as checkReserveTime,
  reserveTimes as getReserveTime
} from '@/api/setting'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    const today = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000))
      .toISOString().substr(0, 10)

    return {
      // ======================
      // V2 STYLE STATE (LOGIC)
      // ======================
      form: {
        reserve_date: today,
        reserve_time: '',
        total_guest: 1
      },
      max_guest: null,
      max_visitors: null,

      // ======================
      // OLD STATE (UI COMPAT)
      // ======================
      reserve_hour: 0,
      reserve_minute: 0,
      list_hours: [],
      list_minutes: [],
      sheetTerm: false,
      dialog: {
        date: false,
        max_visitor: false,
        reserve_time: false
      },
      min_date: today,
      disabled: true,
      time_disabled: false,
      sendToForm: {
        total_guest: 1,
        reserve_time: '',
        reserve_date: today,
        item: []
      },
      availability_slot: 0,
      working_hours: '00:00 - 24:00',
      data_reserve: {},
      guest_store: [
        'seiasekataespressobar',
        'minimizecoffee'
      ],
      visitor_store: [
        'kazunacafe'
      ]
    }
  },

  computed: {
    visitorStore() {
      const url = this.$store.state.url_domain
      return this.visitor_store.indexOf(url) !== -1
    },

    guestStore() {
      const url = this.$store.state.url_domain
      return this.guest_store.indexOf(url) !== -1
    },

    computedDateFormatted() {
      return this.formatDate(this.sendToForm.reserve_date)
    },

    // ✅ V2 STYLE disable logic
    disableNext() {
      return !(
        this.form.reserve_date &&
        this.form.reserve_time &&
        this.form.total_guest
      )
    },

    minDate() {
      if (!this.$isEmpty(this.data_reserve)) {
        if (Number(this.data_reserve.type_time_reservation) === 1) {
          if (Number(this.data_reserve.maximum_time_for_reservation_type) === 0) {
            const date = new Date()
            date.setDate(date.getDate() + this.data_reserve.maximum_time_for_reservation)
            return date.toISOString().substr(0, 10)
          }
        }
      }
      return this.min_date
    },

    list_hour() {
      const list = []
      if (!this.$isEmpty(this.data_reserve) && this.data_reserve.reservation_time_in_date.length > 0) {
        this.data_reserve.reservation_time_in_date.map((item) => {
          item.split_times.map((time) => {
            if (time.time_has_passed === 0) {
              if (this.max_visitors === null || this.max_visitors > time.used_slot) {
                list.push(time.fstart_time)
              }
            }
          })
        })
      }
      return list
    },

    isGuestOverLimit() {
      if (this.max_guest === null || this.max_guest === Infinity) return false
      return this.form.total_guest > this.max_guest
    }
  },

  watch: {
    // ======================
    // SYNC v2 form ↔ v1 UI
    // ======================
    'form.reserve_date'(val) {
      this.sendToForm.reserve_date = val
    },
    'form.reserve_time'(val) {
      this.sendToForm.reserve_time = val
    },
    'form.total_guest'(val) {
      this.sendToForm.total_guest = val
    },

    'sendToForm.reserve_date'(val) {
      this.form.reserve_date = val
    },
    'sendToForm.reserve_time'(val) {
      this.form.reserve_time = val
    },
    'sendToForm.total_guest'(val) {
      this.form.total_guest = val
    },

    minDate(newVal) {
      this.form.reserve_date = newVal
      this.getTimes()
    }
  },

  mounted() {
    this.getWorkingHours()
    this.getTimes()
  },

  methods: {
    onChangeGuest(val) {
      if (val < 1) val = 1

      // kalau ada limit max_guest
      if (this.max_guest !== null && this.max_guest !== Infinity && val > this.max_guest) {
        val = this.max_guest
      }

      this.sendToForm.total_guest = val
      this.form.total_guest = val
    },

    // ======================
    // GUEST LOGIC (V2 STYLE)
    // ======================
    plusGuest() {
      if (this.max_visitors === null || this.form.total_guest < this.max_guest) {
        this.form.total_guest++
      }
    },
    minusGuest() {
      if (this.form.total_guest > 1) {
        this.form.total_guest--
      }
    },

    // ======================
    // DATE LOGIC
    // ======================
    selectDate() {
      this.$refs.dialog_date.save(this.form.reserve_date)
      this.form.reserve_time = ''
      this.form.total_guest = 1
      this.availability_slot = 0
      this.getTimes()
    },

    // ======================
    // GET RESERVE TIME (V2 STYLE)
    // ======================
    async getTimes() {
      this.time_disabled = false
      try {
        const params = {
          reserve_date: this.form.reserve_date
        }

        const { data } = await getReserveTime(params)

        this.data_reserve = data.data
        this.max_visitors = data.data.max_visitors

        if (this.data_reserve.reservation_time_in_date.length === 0) {
          this.time_disabled = true
        } else {
          this.time_disabled = this.data_reserve.reservation_time_in_date.every(item =>
            item.split_times.every(time =>
              time.time_has_passed === 1 ||
              (this.max_visitors !== null && this.max_visitors === time.used_slot)
            )
          )
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },

    // ======================
    // SELECT TIME (V2 STYLE)
    // ======================
    async selectTime() {
      try {
        this.form.reserve_time = this.sendToForm.reserve_time

        const payload = {
          time: this.sendToForm.reserve_time,
          reserve_date: this.sendToForm.reserve_date
        }

        const { data } = await checkReserveTime(payload)

        this.availability_slot = data.data.availability_slot

        // ✅ FIX: kalau null = unlimited
        this.max_guest = data.data.availability_slot === null
          ? Infinity
          : data.data.availability_slot
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },

    // ======================
    // WORKING HOURS
    // ======================
    getWorkingHours() {
      if (!this.$isEmpty(this.$store.state.selected_outlet)) {
        const selected_store = this.$store.state.selected_outlet
        const today = new Date()
        const curTd = today.getDay()
        const working_time = curTd === 0
          ? selected_store.working_hours[6]
          : selected_store.working_hours[curTd - 1]

        if (working_time.times.length > 0) {
          this.working_hours =
            working_time.times[0].fstart_time +
            ' - ' +
            working_time.times[working_time.times.length - 1].fend_time
        }
      }
    },

    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      const locale = getLocale() || process.env.VUE_APP_I18N_LOCALE

      const monthNames = {
        id: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
        en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      }

      const name = monthNames[locale === 'id' ? 'id' : 'en'][parseInt(month) - 1]
      return `${day} ${name} ${year}`
    },

    async selectMenu() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) return

      if (this.form.total_guest <= this.max_guest) {
        this.$store.dispatch('saveDataCartReservation', this.sendToForm)
        this.$router.push({ name: 'reservation_menu' }).catch(() => {})
      } else {
        this.dialog.max_visitor = true
      }
    }
  }
}
</script>
